<form [formGroup]="filterForm" (ngSubmit)="onSubmit()">
  <ap-label [status]="'DEFAULT'">{{ 'FILTERS.ADD.EQ' | translate }}</ap-label>
  <input formControlName="value" type="datetime-local" class="form-control" step="1">
  <button [disabled]="!filterForm.valid" class="btn btn-success" type="submit" attr.aria-label="{{ 'FILTERS.ADD.VALID' | translate }}">{{ 'FILTERS.ADD.VALID' | translate }}</button>
</form>